/*
  Audit Maison Penombre
  Contenu (questions, regles, fiches pieces) vient des metaobjets Shopify,
  serialises par sections/audit-maison-tool.liquid dans les balises
  #aud-data-questions, #aud-data-adjustments, #aud-data-rooms.
  La logique de declenchement des regles vit ici, referencee par le handle
  stable du metaobjet home_adjustment correspondant : le contenu reste
  editable dans Shopify sans toucher ce fichier, mais changer la logique
  de declenchement necessite une modification ici.
*/
(function () {
  "use strict";

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  var QUESTIONS = readJSON("aud-data-questions");
  var ADJUSTMENTS = readJSON("aud-data-adjustments");
  var ROOMS = readJSON("aud-data-rooms");

  function findQuestion(handle) {
    for (var i = 0; i < QUESTIONS.length; i++) {
      if (QUESTIONS[i].handle === handle) return QUESTIONS[i];
    }
    return null;
  }

  function findAdjustment(handle) {
    for (var i = 0; i < ADJUSTMENTS.length; i++) {
      if (ADJUSTMENTS[i].handle === handle) return ADJUSTMENTS[i];
    }
    return null;
  }

  function findRoom(handle) {
    for (var i = 0; i < ROOMS.length; i++) {
      if (ROOMS[i].handle === handle) return ROOMS[i];
    }
    return null;
  }

  /* Alias court vers le handle du metaobjet home_audit_question correspondant */
  var ALIAS_TO_HANDLE = {
    stage: "quel-est-le-stade-de-vie-de-votre-chien",
    age: "quel-est-l-age-de-votre-chien",
    breed: "quelle-est-la-race-ou-le-croisement-de-votre-chien",
    weight: "quel-est-le-poids-de-votre-chien-en-kilogrammes",
    length: "quelle-est-la-longueur-de-votre-chien-du-museau-a-la-base-de-la-queue-en-centimetres",
    withers: "quelle-est-la-hauteur-au-garrot-de-votre-chien-en-centimetres",
    difficulties: "avez-vous-deja-observe-une-difficulte-chez-votre-chien-hesitation-a-sauter-a-monter-ou-descendre-les-escaliers-glissade-sur-un-sol-dur-ou-refus-d-aller-vers-une-piece",
    brutal_change: "changement-brutal-observe",
    arrival_date: "connaissez-vous-la-date-d-arrivee-prevue-de-votre-chien",
    housing_type: "vivez-vous-en-appartement-ou-en-maison",
    floor: "a-quel-etage-se-trouve-votre-logement",
    elevator: "votre-immeuble-dispose-t-il-d-un-ascenseur",
    levels: "combien-de-niveaux-compte-votre-logement",
    outdoor: "votre-logement-dispose-t-il-d-un-balcon-d-une-terrasse-d-un-jardin-ou-d-un-garage",
    car_regular: "une-voiture-sera-t-elle-utilisee-regulierement-avec-votre-chien",
    rooms: "quelles-pieces-de-votre-logement-seront-accessibles-a-votre-chien",
    floor_types: "quels-types-de-sol-trouve-t-on-dans-les-pieces-accessibles",
    sofa_height: "quelle-est-la-hauteur-de-votre-canape-en-centimetres",
    bed_height: "quelle-est-la-hauteur-de-votre-lit-en-centimetres",
    stair_steps: "combien-de-marches-compte-votre-escalier",
    stair_step_height: "quelle-est-la-hauteur-moyenne-d-une-marche-en-centimetres",
    ramp_width: "quelle-largeur-est-disponible-pour-une-eventuelle-rampe-en-centimetres",
    rest_location: "ou-souhaitez-vous-placer-le-couchage-de-votre-chien",
    adults: "combien-d-adultes-vivent-dans-le-logement",
    children: "des-enfants-vivent-ils-dans-le-logement",
    other_animals: "d-autres-animaux-vivent-ils-deja-dans-le-logement",
    frequent_visits: "recevez-vous-des-visites-frequentes",
    risks: "risques-materiels-accessibles"
  };

  /* Etapes affichees a l ecran, dans l ordre. visibleIf est evalue contre
     les reponses deja saisies pour les questions conditionnelles. */
  var STEPS = [
    {
      title: "Le profil de votre chien",
      fields: ["stage", "age", "breed", "weight", "length", "withers", "difficulties", "brutal_change", "arrival_date"]
    },
    {
      title: "Votre logement",
      fields: [
        "housing_type",
        { alias: "floor", visibleIf: function (a) { return a.housing_type === "appartement"; } },
        { alias: "elevator", visibleIf: function (a) { return a.housing_type === "appartement" && Number(a.floor) > 0; } },
        { alias: "levels", visibleIf: function (a) { return a.housing_type === "maison"; } },
        "outdoor",
        "car_regular"
      ]
    },
    { title: "Les pièces accessibles", fields: ["rooms"] },
    {
      title: "Surfaces et hauteurs",
      fields: [
        "floor_types",
        { alias: "sofa_height", visibleIf: function (a) { return (a.rooms || []).indexOf("salon") !== -1; } },
        { alias: "bed_height", visibleIf: function (a) { return (a.rooms || []).indexOf("chambre") !== -1; } },
        { alias: "stair_steps", visibleIf: function (a) { return (a.rooms || []).indexOf("escalier") !== -1; } },
        { alias: "stair_step_height", visibleIf: function (a) { return (a.rooms || []).indexOf("escalier") !== -1; } },
        { alias: "ramp_width", visibleIf: function (a) { return (a.rooms || []).indexOf("escalier") !== -1; } },
        "rest_location"
      ]
    },
    { title: "Les occupants du foyer", fields: ["adults", "children", "other_animals", "frequent_visits"] },
    { title: "Objets et risques présents", fields: ["risks"] }
  ];

  var ROOM_HANDLE_MAP = {
    "entree": "entree",
    "salon": "salon",
    "cuisine": "cuisine",
    "chambre": "chambre",
    "couloir": "couloir",
    "salle de bain": "salle-de-bain",
    "bureau": "bureau",
    "escalier": "escalier",
    "balcon": "balcon",
    "jardin": "jardin",
    "garage": "garage"
  };

  /* ---- Etat ---- */
  var STORAGE_KEY = "penombre_audit_maison_v1";
  var state = {
    screen: "intro",
    stepIndex: 0,
    answers: {}
  };

  function loadState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) {
        var saved = JSON.parse(raw);
        state.answers = saved.answers || {};
        state.stepIndex = saved.stepIndex || 0;
      }
    } catch (e) {}
  }

  function saveState() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ answers: state.answers, stepIndex: state.stepIndex }));
    } catch (e) {}
  }

  function track(eventName, detail) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (detail) {
      for (var k in detail) {
        if (Object.prototype.hasOwnProperty.call(detail, k)) payload[k] = detail[k];
      }
    }
    window.dataLayer.push(payload);
  }

  /* ---- Rendu des questions ---- */
  var root = document.querySelector("[data-aud-root]");
  if (!root) return;

  var screens = {
    intro: root.querySelector('[data-aud-screen="intro"]'),
    form: root.querySelector('[data-aud-screen="form"]'),
    results: root.querySelector('[data-aud-screen="results"]')
  };
  var stepContainer = root.querySelector("[data-aud-step-container]");
  var progressBar = root.querySelector("[data-aud-progress-bar]");
  var progressLabel = root.querySelector("[data-aud-progress-label]");
  var backBtn = root.querySelector("[data-aud-back]");
  var nextBtn = root.querySelector("[data-aud-next]");
  var startBtn = root.querySelector("[data-aud-start]");
  var restartBtn = root.querySelector("[data-aud-restart]");

  function showScreen(name) {
    for (var key in screens) {
      if (screens[key]) screens[key].hidden = key !== name;
    }
    state.screen = name;
  }

  function currentStepFields() {
    var step = STEPS[state.stepIndex];
    if (!step) return [];
    return step.fields
      .map(function (f) {
        return typeof f === "string" ? { alias: f, visibleIf: null } : f;
      })
      .filter(function (f) {
        return !f.visibleIf || f.visibleIf(state.answers);
      });
  }

  function renderStep() {
    var step = STEPS[state.stepIndex];
    if (!step) return;
    stepContainer.innerHTML = "";

    var heading = document.createElement("h2");
    heading.className = "aud-h2";
    heading.textContent = step.title;
    stepContainer.appendChild(heading);

    var fields = currentStepFields();
    fields.forEach(function (f) {
      var handle = ALIAS_TO_HANDLE[f.alias];
      var q = findQuestion(handle);
      if (!q) return;
      stepContainer.appendChild(renderQuestion(f.alias, q));
    });

    progressBar.style.setProperty("--aud-progress", Math.round(((state.stepIndex + 1) / STEPS.length) * 100) + "%");
    progressLabel.textContent = "Étape " + (state.stepIndex + 1) + " sur " + STEPS.length;
    backBtn.disabled = state.stepIndex === 0;
    nextBtn.textContent = state.stepIndex === STEPS.length - 1 ? "Voir mes résultats" : "Suivant";

    track("home_audit_step", { step_index: state.stepIndex + 1, step_title: step.title });
  }

  function renderQuestion(alias, q) {
    var wrap = document.createElement("div");
    wrap.className = "aud-question";

    var label = document.createElement("label");
    label.className = "aud-question__label";
    label.textContent = q.question;
    label.setAttribute("for", "aud-field-" + alias);
    wrap.appendChild(label);

    if (q.guidance) {
      var g = document.createElement("p");
      g.className = "aud-question__guidance";
      g.textContent = q.guidance;
      wrap.appendChild(g);
    }

    var current = state.answers[alias];

    if (q.input_type === "single_select" || q.input_type === "multi_select") {
      var isMulti = q.input_type === "multi_select";
      var optionsWrap = document.createElement("div");
      optionsWrap.className = "aud-options";
      (q.answer_options || []).forEach(function (opt) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "aud-option";
        btn.textContent = opt;
        var isSelected = isMulti
          ? Array.isArray(current) && current.indexOf(opt) !== -1
          : current === opt;
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
        btn.addEventListener("click", function () {
          if (isMulti) {
            var arr = Array.isArray(state.answers[alias]) ? state.answers[alias].slice() : [];
            var idx = arr.indexOf(opt);
            if (idx === -1) {
              arr.push(opt);
            } else {
              arr.splice(idx, 1);
            }
            state.answers[alias] = arr;
          } else {
            state.answers[alias] = opt;
          }
          saveState();
          renderStep();
        });
        optionsWrap.appendChild(btn);
      });
      wrap.appendChild(optionsWrap);
    } else if (q.input_type === "boolean") {
      var boolWrap = document.createElement("div");
      boolWrap.className = "aud-options";
      [["Oui", true], ["Non", false]].forEach(function (pair) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "aud-option";
        btn.textContent = pair[0];
        btn.setAttribute("aria-pressed", current === pair[1] ? "true" : "false");
        btn.addEventListener("click", function () {
          state.answers[alias] = pair[1];
          saveState();
          renderStep();
        });
        boolWrap.appendChild(btn);
      });
      wrap.appendChild(boolWrap);
    } else {
      var input = document.createElement("input");
      input.className = "aud-field";
      input.id = "aud-field-" + alias;
      input.type = q.input_type === "number" ? "number" : q.input_type === "date" ? "date" : "text";
      input.value = current || "";
      input.addEventListener("input", function () {
        state.answers[alias] = input.value;
        saveState();
      });
      wrap.appendChild(input);
    }

    return wrap;
  }

  /* ---- Moteur de regles ----
     Chaque test recoit l objet reponses et renvoie vrai ou faux.
     L ordre de cette liste n a pas d importance, le tri final se fait
     par priorite avec la regle de primaute toujours en tete. */
  var RULES = [
    { handle: "orienter-vers-un-avis-professionnel-en-cas-de-changement-brutal", test: function (a) { return a.brutal_change === true; } },

    { handle: "ranger-les-cables-accessibles", test: function (a) { return hasRisk(a, "câbles accessibles"); } },
    { handle: "ranger-les-medicaments", test: function (a) { return hasRisk(a, "médicaments accessibles"); } },
    { handle: "fermer-les-produits-menagers", test: function (a) { return hasRisk(a, "produits ménagers accessibles"); } },
    { handle: "securiser-la-nourriture-humaine", test: function (a) { return hasRisk(a, "nourriture accessible"); } },
    { handle: "verifier-les-plantes-presentes", test: function (a) { return hasRisk(a, "plantes"); } },
    { handle: "ranger-les-petites-pieces-avalables", test: function (a) { return hasRisk(a, "petites pièces avalables"); } },
    { handle: "bloquer-l-acces-au-balcon", test: function (a) { return hasRisk(a, "balcon non sécurisé"); } },
    { handle: "verifier-la-cloture-du-jardin", test: function (a) { return hasRisk(a, "clôture incertaine") && hasOutdoor(a, "jardin"); } },
    { handle: "bloquer-l-escalier-pour-un-chiot", test: function (a) { return hasRisk(a, "escalier ouvert") && a.stage === "chiot"; } },
    { handle: "bloquer-l-escalier-en-cas-de-difficulte-de-mobilite-connue", test: function (a) { return hasRisk(a, "escalier ouvert") && a.stage !== "chiot" && (hasDifficulty(a, "hésite dans les escaliers") || hasDifficulty(a, "hésite à sauter")); } },
    { handle: "renforcer-la-surveillance-aux-portes-exterieures", test: function (a) { return hasRisk(a, "porte vers l’extérieur") && a.stage === "chiot"; } },

    { handle: "designer-un-emplacement-de-couchage", test: function (a) { return !a.rest_location; } },
    { handle: "fixer-l-emplacement-des-gamelles", test: function (a) { return (a.rooms || []).indexOf("cuisine") !== -1; } },
    { handle: "fermer-les-pieces-non-accessibles", test: function (a) { return Array.isArray(a.rooms) && a.rooms.length > 0 && a.rooms.length < 11; } },
    { handle: "proteger-ou-deplacer-les-objets-fragiles", test: function (a) { return hasRisk(a, "objets fragiles"); } },
    { handle: "prevoir-une-zone-refuge-en-cas-de-visites-frequentes", test: function (a) { return a.frequent_visits === true; } },
    { handle: "prevoir-une-presentation-neutre-avec-un-autre-animal", test: function (a) { return Array.isArray(a.other_animals) && a.other_animals.some(function (v) { return v !== "aucun"; }); } },
    { handle: "definir-les-regles-d-acces-avec-les-enfants", test: function (a) { return a.children === true; } },

    { handle: "observer-le-comportement-sur-sol-glissant", test: function (a) { return hasHardFloor(a) && !hasDifficulty(a, "glisse sur un sol dur"); } },
    { handle: "observer-l-hesitation-devant-le-canape-ou-le-lit", test: function (a) { return (a.sofa_height || a.bed_height) && !hasDifficulty(a, "hésite à sauter"); } },
    { handle: "observer-l-evitement-d-une-piece", test: function (a) { return hasDifficulty(a, "évite une pièce"); } },
    { handle: "observer-la-mobilite-d-un-chien-senior-sans-difficulte-connue", test: function (a) { return a.stage === "senior" && noDifficultyConfirmed(a); } },
    { handle: "observer-le-rythme-d-exploration-d-un-chien-recemment-adopte", test: function () { return true; } },

    { handle: "evaluer-la-compatibilite-d-une-rampe-ou-d-un-escalier", test: function (a) { return (a.rooms || []).indexOf("escalier") !== -1 && hasDifficulty(a, "hésite dans les escaliers"); } },
    { handle: "evaluer-la-compatibilite-d-un-couchage-sureleve-ou-d-un-escalier-salon", test: function (a) { return hasDifficulty(a, "hésite à sauter") && (a.sofa_height || a.bed_height); } },
    { handle: "proposer-des-solutions-a-faible-cout-pour-un-sol-glissant-confirme", test: function (a) { return hasDifficulty(a, "glisse sur un sol dur"); } },
    { handle: "evaluer-la-compatibilite-d-une-rampe-voiture", test: function (a) { return a.car_regular === true && hasDifficulty(a, "hésite à sauter"); } },
    { handle: "recommander-une-protection-de-banquette-pour-un-grand-gabarit", test: function (a) { return a.car_regular === true && Number(a.weight) >= 20; } }
  ];

  function hasRisk(a, key) { return Array.isArray(a.risks) && a.risks.indexOf(key) !== -1; }
  function hasOutdoor(a, key) { return Array.isArray(a.outdoor) && a.outdoor.indexOf(key) !== -1; }
  function hasDifficulty(a, key) { return Array.isArray(a.difficulties) && a.difficulties.indexOf(key) !== -1; }
  function noDifficultyConfirmed(a) { return !Array.isArray(a.difficulties) || a.difficulties.length === 0 || (a.difficulties.length === 1 && a.difficulties[0] === "aucune difficulté observée"); }
  function hasHardFloor(a) { return Array.isArray(a.floor_types) && a.floor_types.some(function (f) { return ["parquet", "carrelage", "béton"].indexOf(f) !== -1; }); }

  function weightToSize(weight) {
    var w = Number(weight);
    if (!w) return null;
    if (w < 10) return "petit";
    if (w < 25) return "moyen";
    if (w < 40) return "grand";
    return "tres grand";
  }

  function evaluateCompatibility(product, weightKg) {
    if (!product) return null;
    if (!weightKg) {
      return { state: "mesure", note: "Renseignez le poids de votre chien pour vérifier la compatibilité." };
    }
    if (product.weight_capacity_kg && Number(weightKg) > Number(product.weight_capacity_kg)) {
      return { state: "incompatible", note: "Le poids déclaré (" + weightKg + " kg) dépasse la charge maximale indiquée pour ce produit (" + product.weight_capacity_kg + " kg)." };
    }
    var size = weightToSize(weightKg);
    var sizeMatches = !product.dog_size || product.dog_size.length === 0 || (size && product.dog_size.indexOf(size) !== -1);
    var note = "";
    var resultState = "mesure";
    if (sizeMatches) {
      resultState = "compatible";
      note = "Ce produit semble compatible avec le poids et le gabarit renseignés. Vérifiez également les dimensions utiles disponibles sur la fiche produit avant l’achat, faute de mesure précise et structurée à ce stade.";
    } else {
      note = "Le gabarit renseigné ne correspond pas clairement aux tailles indiquées pour ce produit. Vérifiez les dimensions avant achat.";
    }
    if (product.data_status && product.data_status !== "verified") {
      note += " Données produit non entièrement vérifiées par le fournisseur à ce jour.";
    }
    return { state: resultState, note: note };
  }

  function computeTriggered() {
    var triggered = RULES.filter(function (rule) {
      return rule.test(state.answers);
    }).map(function (rule) {
      return findAdjustment(rule.handle);
    }).filter(Boolean);

    var priorityOrder = { "1": 0, "2": 1, "3": 2, "4": 3 };
    triggered.sort(function (x, y) {
      if (x.handle === "orienter-vers-un-avis-professionnel-en-cas-de-changement-brutal") return -1;
      if (y.handle === "orienter-vers-un-avis-professionnel-en-cas-de-changement-brutal") return 1;
      return priorityOrder[x.priority] - priorityOrder[y.priority];
    });
    return triggered;
  }

  /* ---- Rendu des resultats ---- */
  function renderResults() {
    var triggered = computeTriggered();

    ["1", "2", "3", "4"].forEach(function (p) {
      var listEl = root.querySelector('[data-aud-list="' + p + '"]');
      listEl.innerHTML = "";
      var items = triggered.filter(function (t) { return t.priority === p; });
      if (items.length === 0) {
        var empty = document.createElement("p");
        empty.className = "aud-microcopy";
        empty.textContent = "Rien à signaler ici selon vos réponses.";
        listEl.appendChild(empty);
        return;
      }
      items.forEach(function (item) {
        listEl.appendChild(renderCard(item));
      });
    });

    renderRoomMap(triggered);

    track("home_audit_complete", { triggered_count: triggered.length });
  }

  function renderCard(item) {
    var card = document.createElement("div");
    card.className = "aud-card" + (item.professional_review_required ? " aud-card--professional" : "");

    var title = document.createElement("p");
    title.className = "aud-card__title";
    title.textContent = item.title;
    card.appendChild(title);

    var meta = document.createElement("p");
    meta.className = "aud-card__meta";
    meta.textContent = (item.room ? item.room + ". " : "") + item.situation;
    card.appendChild(meta);

    if (item.action) {
      var freeLabel = document.createElement("p");
      freeLabel.className = "aud-card__section-label";
      freeLabel.textContent = "Action gratuite";
      card.appendChild(freeLabel);
      var free = document.createElement("p");
      free.className = "aud-card__free";
      free.textContent = item.free_alternative || item.action;
      card.appendChild(free);
    }

    if (item.related_guide) {
      var guideLink = document.createElement("a");
      guideLink.className = "aud-btn aud-btn--ghost";
      guideLink.style.marginTop = "10px";
      guideLink.style.display = "inline-block";
      guideLink.href = item.related_guide;
      guideLink.textContent = "Lire le guide associé";
      guideLink.addEventListener("click", function () {
        track("home_guide_click", { adjustment: item.handle });
      });
      card.appendChild(guideLink);
    }

    if (item.product) {
      var compat = evaluateCompatibility(item.product, state.answers.weight);
      var productWrap = document.createElement("div");
      productWrap.className = "aud-card__product";

      if (item.product.image) {
        var img = document.createElement("img");
        img.src = item.product.image;
        img.alt = item.product.title;
        productWrap.appendChild(img);
      }

      var productInfo = document.createElement("div");
      if (compat) {
        var badge = document.createElement("span");
        badge.className = "aud-card__compat";
        var stateLabels = { compatible: "Compatible selon les données", mesure: "Mesure supplémentaire requise", incompatible: "Incompatible", avis: "Avis professionnel recommandé" };
        badge.setAttribute("data-state", compat.state);
        badge.textContent = stateLabels[compat.state] || compat.state;
        productInfo.appendChild(badge);
      }
      var pTitle = document.createElement("p");
      pTitle.innerHTML = '<a href="' + item.product.url + '">' + item.product.title + "</a> (" + item.product.price + ")";
      productInfo.appendChild(pTitle);
      if (compat) {
        var note = document.createElement("p");
        note.className = "aud-card__limit";
        note.textContent = compat.note;
        productInfo.appendChild(note);
      }
      productWrap.appendChild(productInfo);
      card.appendChild(productWrap);

      var link = productInfo.querySelector("a");
      if (link) {
        link.addEventListener("click", function () {
          track("home_product_click", { adjustment: item.handle });
        });
      }
      track("home_product_match", { adjustment: item.handle, compat_state: compat ? compat.state : null });
    }

    if (item.professional_review_required) {
      var limit = document.createElement("p");
      limit.className = "aud-card__limit";
      limit.textContent = "Cette recommandation reste générale et ne remplace pas un avis vétérinaire adapté à votre chien.";
      card.appendChild(limit);
    }

    return card;
  }

  function renderRoomMap(triggered) {
    var mapList = root.querySelector("[data-aud-map-list]");
    mapList.innerHTML = "";
    var rooms = Array.isArray(state.answers.rooms) ? state.answers.rooms : [];

    rooms.forEach(function (roomKey) {
      var handle = ROOM_HANDLE_MAP[roomKey] || roomKey;
      var profile = findRoom(handle);
      var roomState = "prete";

      triggered.forEach(function (item) {
        if (!item.room) return;
        var matches = item.room === "toutes" || item.room.indexOf(roomKey) !== -1;
        if (!matches) return;
        if (item.priority === "1" && roomState !== "a-securiser") roomState = "a-securiser";
        else if (item.priority === "2" && roomState === "prete") roomState = "a-amenager";
        else if (item.priority === "3" && roomState === "prete") roomState = "a-observer";
      });

      var li = document.createElement("li");
      li.className = "aud-map__item";
      li.setAttribute("data-state", roomState);
      var stateLabels = { "a-securiser": "À sécuriser", "a-amenager": "À aménager", "a-observer": "À observer", "prete": "Prête" };
      li.innerHTML =
        "<strong>" + (profile ? profile.room_name : roomKey) + "</strong>" +
        '<span class="aud-map__state">' + stateLabels[roomState] + "</span>";
      mapList.appendChild(li);

      track("home_room_selected", { room: roomKey, state: roomState });
    });
  }

  /* ---- Navigation ---- */
  if (startBtn) {
    startBtn.addEventListener("click", function () {
      showScreen("form");
      renderStep();
      track("home_audit_start", {});
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener("click", function () {
      if (state.stepIndex < STEPS.length - 1) {
        state.stepIndex += 1;
        saveState();
        renderStep();
      } else {
        showScreen("results");
        renderResults();
      }
    });
  }

  if (backBtn) {
    backBtn.addEventListener("click", function () {
      if (state.stepIndex > 0) {
        state.stepIndex -= 1;
        saveState();
        renderStep();
      }
    });
  }

  if (restartBtn) {
    restartBtn.addEventListener("click", function () {
      state.answers = {};
      state.stepIndex = 0;
      saveState();
      showScreen("intro");
    });
  }

  loadState();
  track("home_hub_view", {});
})();
